import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { Button } from './ui/button';

export default function TrialBanner({ subscription }) {
  if (!subscription) return null;

  if (subscription.tier?.startsWith('trial') && subscription.tier !== 'trial_expired' && subscription.active) {
    const daysLeft = Math.max(0, Math.ceil(
      (new Date(subscription.trial_end) - new Date()) / (1000 * 60 * 60 * 24)
    ));

    const trialLabel =
      subscription.tier === 'trial_plus' ? 'Plus Free Trial' :
      subscription.tier === 'trial_premium' ? 'Premium Free Trial' :
      'Free Trial';

    return (
      <div className="mb-8 bg-[#F5EBE0] border border-[#B94A3E]/30 rounded-md p-4 flex items-center justify-between" data-testid="trial-banner">
        <div className="flex items-center gap-3">
          <AlertCircle className="w-5 h-5 text-[#B94A3E]" />
          <div>
            <p className="font-medium text-[#1A1A1A]">{trialLabel}: {daysLeft} {daysLeft === 1 ? 'day' : 'days'} left</p>
            <p className="text-sm text-[#737373]">You've used {subscription.letters_used}/{subscription.letters_limit} letters and {subscription.photos_used}/{subscription.photos_limit} photos</p>
          </div>
        </div>
        <Link to="/pricing">
          <Button className="bg-[#B94A3E] hover:bg-[#9d3e33] text-white" data-testid="upgrade-btn">
            {subscription.tier === 'trial' ? 'Upgrade or Try Plus' : 'Subscribe Now'}
          </Button>
        </Link>
      </div>
    );
  }

  if (subscription.tier === 'trial_expired' || (!subscription.active && !subscription.stripe_subscription_id)) {
    return (
      <div className="mb-8 bg-red-50 border border-red-200 rounded-md p-4 flex items-center justify-between" data-testid="trial-expired-banner">
        <div className="flex items-center gap-3">
          <AlertCircle className="w-5 h-5 text-red-600" />
          <div>
            <p className="font-medium text-red-900">Your free trial has ended</p>
            <p className="text-sm text-red-700">Subscribe to continue writing letters and generating photos.</p>
          </div>
        </div>
        <Link to="/pricing">
          <Button className="bg-[#B94A3E] hover:bg-[#9d3e33] text-white" data-testid="subscribe-btn">
            Choose Plan
          </Button>
        </Link>
      </div>
    );
  }

  return null;
}
